/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Network_Search_PlaceholderInputs */

const fr_map_network_search_placeholder = /** @type {(inputs: Map_Network_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher un réseau ou une ville...`)
};

const en_map_network_search_placeholder = /** @type {(inputs: Map_Network_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for a network or city...`)
};

/**
* | output |
* | --- |
* | "Search for a network or city..." |
*
* @param {Map_Network_Search_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_network_search_placeholder = /** @type {((inputs?: Map_Network_Search_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Network_Search_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_network_search_placeholder(inputs)
	return en_map_network_search_placeholder(inputs)
});